module.exports = __webpack_public_path__ + "static/media/list.acc5fd1b.svg";